<template>
	<div class="publicBack iconfont icon-gengduo-copy" @click="back" :style="setStyle" v-if="isShowBack"></div>
</template>

<script>
	export default {
		name: 'publicBack',
		props: {
			setStyle: {
				type: Object,
				default: () => ({})
			},
			BackNum: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				isShowBack: false
			}
		},
		mounted() {
			this.checkHistory();
			// 监听路由变化，重新检查
			this.$watch(() => this.$route, () => {
				this.checkHistory();
			});
		},
		methods: {
			checkHistory() {
				this.isShowBack = (window.__APP_ROUTE_COUNT__ || 0) > 1;
			},
			back() {
				if (this.isShowBack) {
					this.$historyBack(this.BackNum);
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.publicBack {
		position: absolute;
		left: -42px;
		top: 0;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
		color: #0D68FF;
		padding: 8px 10px;
		font-size: 14px;
		font-weight: bold;
		cursor: pointer;
	}
</style>